import MobileHeader from "./Header";
import { Box, Typography, useTheme } from "@mui/material";
import NotifStatusIcon from "../../../../media/images/icons/notif-status";
import { useAppSelector } from "../../../../hooks/useRedux";
import NotifCard from "./NotifCard";

export default function NotifsPage() {
  const theme = useTheme();

  const messages = useAppSelector((state) => state.settings.messages);

  return (
    <>
      <MobileHeader />
      <Box
        sx={{
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          padding: "8px",
        }}
      >
        <NotifStatusIcon size={23} color={theme.palette.secondary.main} />

        <Typography
          sx={{
            fontWeight: "600",
          }}
          component="span"
          color="secondary.main"
        >
          اعلان های شما
        </Typography>

        {/* <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          شما
          <Typography
            sx={{
              fontWeight: "600",
            }}
            component="span"
            color="secondary.main"
          >
            {" 0 اعلان جدید "}
          </Typography>
          دارید
        </Typography> */}
      </Box>

      <Box
        sx={{
          padding: "16px",
          flex: "1",
        }}
      >
        {messages?.length ? (
          <Box
            sx={{
              flex: "1",
              overflow: "auto",
              paddingX: "8px",
              paddingY: "8px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {messages.map((item) => (
              <NotifCard {...item} />
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>اعلانی وجود ندارد!</Typography>
          </Box>
        )}
      </Box>

      {/* <CustomTopTabbar
        setValue={setActiveTab}
        value={activeTab}
        tabs={["همه", "حساب کاربری", "اطلاعیه"].map((item, index) => (
          <NotifTabButton
            counts={0}
            label={item}
            active={index === activeTab}
          />
        ))}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
      </CustomTopTabbar> */}
    </>
  );
}
